import React from "react";
import { useTranslation } from "react-i18next";

function TranslatorComponent() {
  const { i18n } = useTranslation();
  const language = (i18n.resolvedLanguage || i18n.language || "en").split("-")[0];
  return (
    <div className="picker-lang-rigsave" aria-label="Language">
      {["it", "en"].map((code, index) => (
        <React.Fragment key={code}>
          {index > 0 && <span aria-hidden="true"> / </span>}
          <button type="button" lang={code} aria-pressed={language === code}
            className={language === code ? "active" : undefined}
            onClick={() => i18n.changeLanguage(code)}>{code.toUpperCase()}</button>
        </React.Fragment>
      ))}
    </div>
  );
}
export default TranslatorComponent;
